module.exports = __webpack_public_path__ + "img/restaurant_bodyimage03.5ad05885.jpg";